export class MatchIdent {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.name = "MatchIdent";
    this.scene = "MatchIdent";
    this.data = [];
    this.page = 1401;
    this.comms_page = 1402;
  }

  async preview({ options }) {
    this.onAir = false;
    this.options = options;
    let xml = await this.getVizPage({ page: this.page });

    let kit = options.home_kit;

    let BGColour = options.game.home_team.variables?.[kit + "_clock_bg"];
    try {
      xml.payload.field.find((item) => {
        return item.attr.name === "000502"; // home team back colour
      }).value =
        "IMAGE*__SKY_SPORTS/TEAM_ELEMENTS/UNIVERSAL/TEAM_COLOURS/" + BGColour;
    } catch (err) {}

    try {
      let stripeColour =
        options.game.home_team?.variables?.[kit + "_kit_stripe_viz"];
      xml.payload.field.find((item) => {
        return item.attr.name === "000512"; // home team back colour
      }).value =
        "IMAGE*__SKY_SPORTS/TEAM_ELEMENTS/UNIVERSAL/TEAM_COLOURS/" +
        (stripeColour ?? BGColour);
    } catch (err) {}

    kit = options.away_kit;

    BGColour = options.game.away_team.variables?.[kit + "_clock_bg"];
    try {
      xml.payload.field.find((item) => {
        return item.attr.name === "000602"; // home team back colour
      }).value =
        "IMAGE*__SKY_SPORTS/TEAM_ELEMENTS/UNIVERSAL/TEAM_COLOURS/" + BGColour;
    } catch (err) {}

    try {
      let stripeColour =
        options.away_team?.variables?.[kit + "_kit_stripe_viz"];
      xml.payload.field.find((item) => {
        return item.attr.name === "000612"; // home team back colour
      }).value =
        "IMAGE*__SKY_SPORTS/TEAM_ELEMENTS/UNIVERSAL/TEAM_COLOURS/" +
        (stripeColour ?? BGColour);
    } catch (err) {}

    xml.payload.field.find((item) => {
      return item.attr.name === "100"; // Number
    }).value = options.game?.home_team?.variables?.badge || "";
    // xml.payload.field.find((item) => {
    //   return item.attr.name === "101"; // Number
    // }).value = options.game?.home_team?.variables?.alpha_badge || "";

    xml.payload.field.find((item) => {
      return item.attr.name === "120"; // Number
    }).value = options.game?.away_team?.variables?.badge || "";

    xml.payload.field.find((item) => {
      return item.attr.name === "200"; // Number
    }).value = options.subtitle;

    xml.payload.field.find((item) => {
      return item.attr.name === "103"; // Number
    }).value = options?.game?.home_team?.short_name;

    xml.payload.field.find((item) => {
      return item.attr.name === "123"; // Number
    }).value = options?.game?.away_team?.short_name;

    await this.updateVizPage({ page: this.page, data: xml });
    this.sendPreview("page:read " + this.page);
    this.comms(options);
  }

  async comms(options) {
    let xml = await this.getVizPage({ page: this.comms_page });

    xml.payload.field.find((item) => {
      return item.attr.name === "100"; // Number
    }).value =
      options.game?.home_team?.variables?.alt_badge ||
      options.game?.home_team?.variables?.badge ||
      "";

    xml.payload.field.find((item) => {
      return item.attr.name === "120"; // Number
    }).value =
      options.game?.away_team?.variables?.alt_badge ||
      options.game?.away_team?.variables?.badge ||
      "";

    xml.payload.field.find((item) => {
      return item.attr.name === "103"; // Number
    }).value = options?.commentators?.toUpperCase();

    await this.updateVizPage({ page: this.comms_page, data: xml });
  }

  animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
    this.timeout = setTimeout(() => {
      this.onAir = false;
      this.commsOnAir = true;
      this.sendAnimate({ page: this.comms_page });
    }, 5000);
  }
  animateOff({ options }) {
    clearTimeout(this.timeout);
    this.sendAnimateOff({ page: this.onAir ? this.page : this.comms_page });
    this.onAir = false;
    this.commsOnAir = false;
  }
}
